import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import PageWrapper from '../components/PageWrapper';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { mockJobs } from '../data/mockData';

const JobDetail = () => {
  const { id } = useParams();
  const job = mockJobs.find(j => j.id === parseInt(id)) || mockJobs[0];
  const currentUrl = window.location.href;
  
  // Updated Phone Number
  const whatsappMsg = encodeURIComponent(`Hallo, ich interessiere mich für die Stelle: ${job.title} (ID: ${job.id}).`);

  return (
    <PageWrapper className="bg-slate-50 py-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <Link to="/jobs" className="text-cyan-600 hover:text-blue-900 flex items-center gap-2 mb-6 font-medium">
          <SafeIcon icon={FiIcons.FiArrowLeft} /> Zurück zur Übersicht
        </Link>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
          
          <div className="bg-blue-900 text-white p-8 md:p-12">
            <div className="flex flex-col md:flex-row justify-between items-start gap-6">
              <div>
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="bg-blue-800 text-blue-100 text-xs px-3 py-1 rounded-full">{job.category}</span>
                  <span className="bg-blue-800 text-blue-100 text-xs px-3 py-1 rounded-full">{job.type}</span>
                </div>
                <h1 className="text-3xl md:text-4xl font-bold mb-4">{job.title}</h1>
                <div className="flex flex-wrap gap-6 text-blue-200 text-sm">
                  <span className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiMapPin} /> {job.location}</span>
                  <span className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiClock} /> {job.date}</span>
                </div>
              </div>
              <div className="bg-white p-3 rounded-xl shadow-lg shrink-0 text-center">
                <QRCodeSVG value={currentUrl} size={100} />
                <p className="text-[10px] text-slate-500 mt-2">Stelle teilen</p>
              </div>
            </div>
          </div>

          <div className="p-8 md:p-12">
            <div className="grid md:grid-cols-3 gap-12">
              <div className="md:col-span-2 space-y-8">
                <section>
                  <h2 className="text-2xl font-bold text-blue-900 mb-4">Stellenbeschreibung</h2>
                  <p className="text-slate-600 leading-relaxed">{job.desc}</p>
                </section>
                
                <section>
                  <h2 className="text-2xl font-bold text-blue-900 mb-4">Anforderungen</h2>
                  <ul className="space-y-2">
                    {job.requirements.map((req, idx) => (
                      <li key={idx} className="flex items-start text-slate-600">
                        <SafeIcon icon={FiIcons.FiCheck} className="text-cyan-500 mr-3 mt-1 shrink-0" />
                        {req}
                      </li>
                    ))}
                  </ul>
                </section>
              </div>

              <div className="bg-slate-50 p-6 rounded-xl border border-slate-100 h-fit space-y-6">
                <div>
                  <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-1">Gehalt / Lohn</h3>
                  <p className="font-medium text-slate-800">{job.salary}</p>
                </div>
                <div>
                  <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-1">Deutschkenntnisse</h3>
                  <p className="font-medium text-slate-800">{job.germanLevel}</p>
                </div>
                <div>
                  <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-1">Unterkunft</h3>
                  <p className="font-medium text-slate-800">{job.accommodation}</p>
                </div>

                <div className="pt-6 border-t border-slate-200">
                  <Link to="/bewerber" className="w-full bg-blue-900 text-white font-bold py-3 px-4 rounded-md hover:bg-blue-800 transition-colors text-center block mb-3 shadow-md">
                    Jetzt bewerben
                  </Link>
                  <a 
                    href={`https://wa.me/491605074395?text=${whatsappMsg}`} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-full bg-green-500 text-white font-bold py-3 px-4 rounded-md hover:bg-green-600 transition-colors text-center flex items-center justify-center gap-2 shadow-md"
                  >
                    <SafeIcon icon={FiIcons.FiMessageCircle} /> Per WhatsApp bewerben
                  </a>
                </div>
                
                <div className="flex justify-center gap-4 pt-4 border-t border-slate-200">
                  <span className="text-slate-400 text-sm flex items-center justify-center w-full">Teilen:</span>
                  <a href={`mailto:?subject=Interessante Stelle&body=${currentUrl}`} className="text-slate-400 hover:text-blue-900"><SafeIcon icon={FiIcons.FiMail} /></a>
                  <a href={`https://wa.me/?text=${currentUrl}`} target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-green-500"><SafeIcon icon={FiIcons.FiMessageCircle} /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default JobDetail;